import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Grid, Stack, Typography } from '@mui/material';
import NotFoundSVG from '@common-assets/svg/not-found.svg';
export var PageNotFoundContent = function(param) {
    var _param_showHomeButton = param.showHomeButton, showHomeButton = _param_showHomeButton === void 0 ? true : _param_showHomeButton;
    var t = useTranslation('main').t;
    return /*#__PURE__*/ _jsxs(Stack, {
        sx: {
            minHeight: '70vh',
            justifyContent: 'center',
            alignItems: 'center'
        },
        spacing: 5,
        children: [
            /*#__PURE__*/ _jsx(Grid, {
                container: true,
                item: true,
                xs: 12,
                justifyContent: "center",
                alignItems: "center",
                children: /*#__PURE__*/ _jsx("svg", {
                    style: {
                        height: 300,
                        width: 384
                    },
                    "data-src": NotFoundSVG,
                    "data-loading": "lazy"
                })
            }),
            showHomeButton && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "subtitle1",
                        paragraph: true,
                        children: t('organisms.pageNotExist')
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        href: "/",
                        variant: "contained",
                        size: "large",
                        sx: {
                            '&:hover': {
                                color: '#fff'
                            }
                        },
                        children: t('organisms.backToHomeBtn')
                    })
                ]
            })
        ]
    });
};
